<template>
  <div class="suggest">
    <h2>Suggest A Vote</h2>
    <p v-if="!formSubmitted">We're always looking for good examples of federal-level votes that show the differences between the two major parties.  Feel free to submit one!</p>
    
    <div id="suggest-submitted" v-if="formSubmitted">
      <h3>Got it, thanks!</h3>
      <p>We'll evaluate the vote you sent, and if it's a great submission, we'll add it to the site, with a thank you!</p>
    </div>

    <form class="suggest-form" v-if="!formSubmitted" @submit="formSubmit" name="vote_suggestions" method="POST" data-netlify-honeypot="bot-field" data-netlify="true">
      <div id="suggest-email">
        <label>Your email</label>
        <input type="email" name="email" v-model.lazy.trim="emailValue" :class="{invalid: (emailValue && !emailValid)}" required placeholder="your@email.please" />
      </div>
      <div id="suggest-url">
        <label>Suggested vote</label>
        <input type="url" name="suggested_url" v-model.trim="urlValue" :class="{invalid: (urlValue && !urlValid)}" required placeholder="https://congress.gov/etc" />
        <span class="suggest-helper">Must be a full link to a reputable site, including congress.gov, house.gov, senate.gov, or govtrack.us</span>
      </div>
      <div data-netlify-recaptcha="true"></div>
      <div id="suggest-submit">
        <button type="submit" :disabled="!formValid">Submit</button>
      </div>
      <input type="hidden" name="form-name" value="vote_suggestions" />
    </form>
  </div>
</template>

<style scoped lang="scss">

  .suggest {
    width: 40vw;
    margin: 0 auto 48px;

    p {
      text-align: left;
    }

    a {
      text-decoration: underline;
    }

    form {

      div {
        padding: 1rem;
      }

      label {
        display: inline-block;
        width: 40%;
        text-align: right;
        padding-right: 1rem;
      }

      input {
        display: inline-block;
        width: 60%;
        padding: 0.5rem;
        border-radius: 8px;
        font-size: 1rem;
        text-align: left;
        border: 1px solid #999;

        &.invalid {
          border-color: #b5403c;
        }
      }

      .suggest-helper {
        display: block;
        padding-left: 40%;
        padding-top: 2px;
        font-size: 0.67rem;
        text-align: left;
      }

      #suggest-submit {
        padding-left: 40%;
        overflow: auto;

        button {
          display: inline-block;
          padding: 0.5rem 1rem;
          font-size: 1rem;
          border-radius: 8px;
          border: 1px solid #999;
          float: right;
        }
      }
    }
  }

  @media (min-width: 320px) and (max-width: 768px) {
    .suggest {
      width: 80vw;

      form.suggest-form {
        label {
          text-align: left;
          display: block;
          width: 100%;
        }

        input {
          display: block;
          width: 100%;
        }

        label {
          text-align: left;
        }

        .suggest-helper {
          display: block;
          padding-left: 0;
          padding-top: 2px;
          font-size: 0.67rem;
          text-align: left;
        }
      }
    }
  }

</style>

<script>
export default {
  name: 'Suggest',

  components: {
  },

  props: [ ],
  
  data: () => ({
    emailActive: false,
    emailValid: false,
    urlActive: false,
    urlValid: false,
    formSubmitted: false,
    emailValue: '',
    urlValue: ''
  }),
  
  methods: {
    formSubmit(e) {
      e.preventDefault()

      if (!this.formValid) {
        return false
      }

      //from netlify
      const myForm = event.target
      const formData = new FormData(myForm)
        
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString()
      })
        .then(() => { this.formSubmitted = true })
        .catch((error) => alert(error))
    }
  },

  watch: {
    emailValue() {
      const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/gi
      
      this.emailValid = emailRegex.test(this.emailValue)

      // console.log("EMAIL VALID?", this.emailValid)
    },

    urlValue() {
      const urlRegex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi
      const urlDomainRegex = /^https:\/\/(.*\.)*((congress\.gov)|(house\.gov)|(senate\.gov)|(govtrack\.us))/gi

      this.urlValid = (urlRegex.test(this.urlValue) && urlDomainRegex.test(this.urlValue))

      // console.log("URL VALID?", this.urlValid)
    }
  },

  computed: {
    formValid() {
      return (this.emailValid && this.urlValid)
    }
  }

}


</script>



